import Product from './Product'

export { Product }

export default Product
